<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
      text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index" router>
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">
                  {{ threeItem.title }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                {{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from '../common/bus'
export default {
  data() {
    return {
      collapse: false
    }
  },
  computed: {
    onRoutes() {
      return this.$route.path
    },
    items() {
      const items = [{ icon: 'el-icon-s-home', index: '/home', title: '工作台' }]
      const routes = this.$store.state.permission.routes || []
      routes.forEach(route => {
        if (!route || !route.meta || route.meta.hidden || route.path === '/') return
        const item = this.routeMenuItem(route, '')
        if (item) items.push(item)
      })
      return items
    }
  },
  methods: {
    routePath(parentPath, path) {
      const current = String(path || '')
      if (current.charAt(0) === '/') return current
      return `${String(parentPath || '').replace(/\/$/, '')}/${current}`.replace(/\/+/g, '/')
    },
    routeMenuItem(route, parentPath) {
      const index = this.routePath(parentPath, route.path)
      const children = (route.children || []).filter(child => child && child.meta && !child.meta.hidden)
      const item = {
        icon: route.meta.icon,
        index,
        title: route.meta.title
      }
      if (children.length > 1) {
        item.subs = children.map(child => this.routeMenuItem(child, index)).filter(Boolean)
      } else if (children.length === 1) {
        item.index = this.routePath(index, children[0].path)
      }
      return item
    }
  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', msg => {
      this.collapse = msg
    })
  }
}
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar>ul {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue